import { transformAllContentItems } from "../library";
import { getBaseSection, getSectionByIndex } from "../../path/library";
import {
    CONTENTITEM_PROP_EXCLUSION_LIST_BY_PATH,
    CONTENTITEM_PROP_EXCLUSION_LIST_BY_BASEPATH,
    NULL_COMPONENTS_BY_VARIANT,
} from "./constants";
import { CardVariantsEnum } from "./types";
import {
    PLAYLIST,
    CAROUSEL,
} from "../../../components/LayoutFactory/constants";
import { convertImageDerivativesIntoSrcSet } from "../utils";

const getNullPropsByVariant = (variant) => {
    return NULL_COMPONENTS_BY_VARIANT[variant] || {};
};

const getExclusionPropsByPath = (path) => {
    let exclusionProps = CONTENTITEM_PROP_EXCLUSION_LIST_BY_PATH.get(path);
    if (!exclusionProps) {
        const basePath = path?.split("/")[0] ?? "";
        exclusionProps =
            CONTENTITEM_PROP_EXCLUSION_LIST_BY_BASEPATH.get(basePath) ?? [];
    }

    return exclusionProps.reduce((propsToNull, prop) => {
        if (!prop) return propsToNull;

        propsToNull[prop] = null;

        return propsToNull;
    }, {});
};

const transformContentItemDepartments = (contentItem) => {
    const { departments, show } = contentItem;
    if (departments?.sectionLabels?.length || departments?.sectionList?.length)
        return contentItem.departments;

    return {
        sectionLabels: [show],
        sectionList: [show],
    };
};

// some layouts do not have user selected variant options in nine, so we need to set their default variant here
// layout.variant is needed in the transformForLayouts function
const setLayoutDefaultsByName = (layout) => {
    if (layout.name === PLAYLIST) {
        layout = { ...layout, variant: CardVariantsEnum.HORIZONTAL };
    } else if (layout.name === CAROUSEL) {
        layout = { ...layout, variant: CardVariantsEnum.MINIMAL };
    }
    return layout;
};

export const transformForLayouts = (contentItems, layout, path) => {
    layout = setLayoutDefaultsByName(layout);

    const exclusionPropsByPath = getExclusionPropsByPath(path);
    const nullPropsByVariant = getNullPropsByVariant(layout.variant);
    const baseSection = getBaseSection(path);
    const subSection = getSectionByIndex(path, 1);

    return contentItems.map((contentItem) => {
        return {
            ...contentItem,
            image: {
                url: contentItem.imageURL,
                srcset: convertImageDerivativesIntoSrcSet(contentItem.image),
                aspects: {
                    ratio1x1: {
                        url: contentItem.image?.aspects?.ratio1x1?.url,
                    },
                    ratio16x9: {
                        url: contentItem.image?.aspects?.ratio16x9?.url,
                    },
                },
            },
            departments: transformContentItemDepartments(contentItem),
            ...nullPropsByVariant,
            ...exclusionPropsByPath,
            variant: layout.variant,
            baseSection,
            subSection,
        };
    });
};

export const parseContentQueryWidget = (content, page) => {
    if (!content) return;

    const { type, sourceId, pageWidget } = content;

    //do nothing if valuable information is missing
    if (
        !type ||
        !sourceId ||
        !pageWidget?.metadata?.layout ||
        !pageWidget?.payload
    )
        return;

    const { path } = page;
    const { layout, query } = pageWidget.metadata;

    // get slug from lineup to apply contextual headlines
    const contextualHeadlineSlug = query?.lineupSlug ?? "";

    let transformedItems = transformAllContentItems(
        pageWidget.payload.items,
        contextualHeadlineSlug
    );

    transformedItems = transformForLayouts(transformedItems, layout, path);

    return {
        type,
        sourceId,
        pageWidget: {
            ...pageWidget,
            payload: {
                items: transformedItems,
            },
        },
    };
};
